import React from 'react';
import styled from 'styled-components';
import {TypographyChildrenProps} from './Typography';
import {getLocale} from '@epic-core/common';
import {CombinedTextColorProps, useCombinedTextColor} from 'epic-ue-theme';

interface TypographyHeading4Props {
    big?: boolean;
}

const Heading = styled.h4<TypographyHeading4Props & CombinedTextColorProps>`
    font-family: ${(p) => p.theme.fonts.brutal.medium};
    &.big {
        font-family: ${(p) => p.theme.fonts.brutal.bold};
    }
    &.loc-en-US {
        font-family: ${(p) => p.theme.fonts.fira.medium};
        &.big {
            font-family: ${(p) => p.theme.fonts.fira.bold};
        }
    }

    &.loc-ja,
    &.loc-zh-CN,
    &.loc-ko {
        font-size: ${(p) => (p.big ? '20px' : '16px')};
    }

    &.loc-ja {
        font-family: ${(p) => p.theme.fonts.notosans.japanese};
    }
    &.loc-ko {
        font-family: ${(p) => p.theme.fonts.notosans.korean};
        word-wrap: break-word;
        word-break: keep-all;
    }
    &.loc-zh-CN {
        font-family: ${(p) => p.theme.fonts.notosans.chinese};
    }
    font-weight: ${(p) => (p.big ? '700' : '500')};
    font-size: ${(p) => (p.big ? '15px' : '13px')};
    line-height: ${(p) => (p.big ? '20px' : '18px')};
    letter-spacing: ${(p) => (p.big ? '4px' : '3px')};
    text-transform: uppercase;
    margin: 0;
    color: ${(p) => useCombinedTextColor(p.color)};
`;

export const TypographyHeading4 = ({
    children,
    big,
    color,
    as,
    className = ''
}: TypographyChildrenProps & TypographyHeading4Props): JSX.Element => {
    return (
        <Heading
            className={`heading h4 ${big ? 'big' : ''} loc-${getLocale()} ${className}`}
            big={big}
            color={color}
            as={as}>
            {children}
        </Heading>
    );
};
